import { render } from "./Index.vue?vue&type=template&id=215b8676"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=215b8676&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Modal/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "215b8676"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('215b8676', __exports__)) {
    api.reload('215b8676', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=215b8676", () => {
    api.rerender('215b8676', render)
  })

}


export default __exports__